import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberWithCommas',
    standalone: false
})
export class NumberWithCommasPipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const num = Number(value);
    if (!Number.isFinite(num)) {
      return '';
    }

    const sign = num < 0 ? '-' : '';
    return sign + Math.abs(num).toLocaleString('en-US');
  }
}

